import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-help',
  templateUrl: './grid-help.component.html',
  styleUrls: ['./grid-help.component.scss'],
})
export class GridHelpComponent implements OnInit {
  @Input() helpList: any[];
  @Input() goBack: any;

  constructor() {}

  ngOnInit() {}
}
